export interface Order {
    orderDetails: OrderDetail[];
    productChoice: ProductChoice;
    measure: Measure;
  }
  
  export interface OrderDetail {
    orderDetailsSourceId: number;
    orderDetailsSourceValueId: number;
    orderDetailsSourceValue: string;
  }
  
  export interface ProductChoice {
    productId: number;
    modelId: number;
    attributeOptions: ProductAttributeOption[];
  }
  
  export interface ProductAttributeOption {
    attributeOptionId: number;
    valueId: number;
  }
  
  export interface Measure {
    measurements: Measurement[];
    accessories: Accessory[];
  }
  
  export interface Measurement {
    attributeOptionId: number;
    attributeOptionName: string;
    measures: MeasureDetail[];
  }
  
  export interface MeasureDetail {
    baseMeasurementId: number;
    baseMeasurementName: string;
    measure: string;
    selectedValue:string;
  }
  
  export interface Accessory {
    accessoryId: number;
    accessoryName: string;
    options: AccessoryOption[];
  }
  
  export interface AccessoryOption {
    attributeOptionId: number;
    attributeOptionName: string;
    valueId: number;
    value: string;
    image: string;
    selectedValue:string;
  }

  export interface PatchOrderStatus {
    orderNumber: string;
    orderStatus: string;
  }

  export enum OrderStatus {
    ToQuote,
    Quote,
    Quoted,
    Submitted,
    Ordered,
    Despatched,
    Cancelled,
    Saved,
    ReadyToSubmit
  }